// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"117d092a","351":"9bc94e45"}[chunkId] + ".chunk.js";
};